import { UserGroupMembershipTablePanel } from "#src/batteries-included-components/Panels/TablePanels/UserGroupMembershipTablePanel";
import classNames from "classnames/bind";
import React from "react";
import { UserDetailsPanel } from "../../Panels/DetailsPanel/UserDetailsPanel";
import styles from "./UserSummaryTab.module.scss";

const cx = classNames.bind(styles);

export const UserSummaryTab = ({ isHumanUser }: { isHumanUser: boolean }) => {
  return (
    <div className={cx("container")}>
      <div className={cx("contentContainer")}>
        <UserDetailsPanel />
        {isHumanUser ? <UserGroupMembershipTablePanel /> : null}
      </div>
    </div>
  );
};
